var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.791 11.3997V23.9997C28.791 24.7729 28.1643 25.3997 27.391 25.3997H2.19102C1.41782 25.3997 0.791016 24.7729 0.791016 23.9997V11.3997H28.791ZM28.791 5.79971H0.791016V1.59971C0.791016 0.826501 1.41782 0.199707 2.19102 0.199707H27.391C28.1643 0.199707 28.791 0.826501 28.791 1.59971V5.79971Z",
    fill: "#6848E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseIcon);
export default __webpack_public_path__ + "static/media/purchaseIcon.5e58442ed7942e78f69cfac92dfa976c.svg";
export { ForwardRef as ReactComponent };